import { ReactNode, useId } from 'react';

import FacialHair from './facialHair';
import HatColor, { Blue03 } from './HatColor';

const Turban = ({ children }: { children: ReactNode }) => {
  const uniqueId = useId();
  const filter1 = `${uniqueId}-filter1`;
  const mask1 = `${uniqueId}-mask1`;
  const mask2 = `${uniqueId}-mask2`;
  const mask3 = `${uniqueId}-mask3`;
  const path1 = `${uniqueId}-path1`;
  const path2 = `${uniqueId}-path2`;
  const path3 = `${uniqueId}-path3`;

  return (
    <g id="Top" strokeWidth="1" fillRule="evenodd">
      <defs>
        <rect id={path1} x="0" y="0" width="264" height="280" />
        <path
          d="M156,180.610951 C173.530782,172.282984 186.048193,155.114792 187.791419,134.867187 C193.569129,134.002364 198,129.018625 198,123 L198,110 C198,104.054007 193.675427,99.1180731 188,98.1659169 L188,92 C188,61.072054 162.927946,36 132,36 C101.072054,36 76,61.072054 76,92 L76,92 L76,98.1659169 C70.3245733,99.1180731 66,104.054007 66,110 L66,123 C66,129.018625 70.4308707,134.002364 76.2085808,134.867187 C77.9518066,155.114792 90.4692178,172.282984 108,180.610951 L108,199 L104,199 L104,199 C64.235498,199 32,231.235498 32,271 L32,280 L232,280 L232,271 C232,231.235498 199.764502,199 160,199 L156,199 L156,180.610951 Z M0,5.68434189e-14 L264,5.68434189e-14 L264,280 L0,280 L0,5.68434189e-14 Z"
          id={path2}
        />
        <path
          d="M83.9715543,55.8170792 C107.404232,69.414362 145.114919,82.1112884 139,138 C158.377483,132.360101 168.044149,116.801277 168,91.3235294 C167.918252,44.1482824 115.850571,6.80154462e-15 86,0 C85.3259486,0 84.6559706,0.0296343787 83.9916946,0.0880669528 C83.3328225,0.0296343217 82.6684563,0 82.0002187,0 C52.0737254,6.80154462e-15 0.0804892181,44.1482783 0.00021866091,91.3235294 C-0.0442202163,117.440393 9.62244645,132.999216 29.0002187,138 C22.8618971,82.1112789 60.5101967,69.4143577 83.9715662,55.8170722 Z"
          id={path3}
        />
        <filter
          x="-0.8%"
          y="-2.0%"
          width="101.5%"
          height="108.0%"
          filterUnits="objectBoundingBox"
          id={filter1}
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0"
            type="matrix"
            in="shadowOffsetOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <mask id={mask1} fill="white">
        <use xlinkHref={'#' + path1} />
      </mask>
      <g id="Mask" />
      <g id="Top/Accesories/Turban" mask={`url(#${mask1})`}>
        <g transform="translate(-1.000000, 0.000000)">
          <FacialHair />
          <g
            id="Behind"
            strokeWidth="1"
            fillRule="evenodd"
            transform="translate(1.000000, 0.000000)"
          >
            <mask id={mask2} fill="white">
              <use xlinkHref={'#' + path2} />
            </mask>
            <g id="Mask-Hair" />
          </g>
          <g
            id="Turban"
            strokeWidth="1"
            fillRule="evenodd"
            transform="translate(1.000000, 0.000000)"
          >
            <path
              d="M74.5304294,97.5 C73.529284,95.0905557 73,92.5798498 73,90 C73,71.7746033 99.4151998,57 132,57 C164.5848,57 191,71.7746033 191,90 C191,92.5798498 190.470716,95.0905557 189.469571,97.5 C183.398106,82.8878805 159.972341,72 132,72 C104.027659,72 80.6018941,82.8878805 74.5304294,97.5 Z"
              id="Band"
              fill="#EDECE3"
            />
            <g transform="translate(48.000000, 3.000000)">
              <mask id={mask3} fill="white">
                <use xlinkHref={'#' + path3} />
              </mask>
              <use id="Turban-Mask" fill="#124C74" xlinkHref={'#' + path3} />
              <HatColor maskID={mask3} defaultColor={Blue03} />
            </g>
            <path
              d="M48.0110963,96.0123559 C48.3807929,121.112082 58.0438337,136.107963 77.0002187,141 C57.6224465,136.289117 47.9557798,121.632254 48.0002187,97.0294118 C48.0008313,96.6902213 48.0044682,96.351197 48.0110963,96.0123559 Z M152.645822,30.4681115 C153.39011,36.1953086 152.126202,42.8891982 148.000219,50.135763 C136.847465,71.5667661 76.561434,72.0039826 76.3339794,129.679698 C76.1051437,67.7612631 136.805324,67.3799133 148.000219,44.5441176 C150.669864,39.5668152 152.141299,34.8351296 152.645822,30.4681115 Z"
              id="Shadow"
              fillOpacity="0.16"
              fill="#000000"
            />
          </g>
          {children}
        </g>
      </g>
    </g>
  );
};

Turban.displayName = 'Turban';
export default Turban;
